import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as searchActions from '../../actions/search';
import SearchPage from './SearchPage';

const mapStateToProps = ({ settings, search }) => ({
  ...settings,
  ...search,
  xPropMode: window.xprops.data.mode,
  onTrigger: window.xprops.onTrigger,
});

const mapDispatchToProps = (dispatch) => ({
  searchActions: bindActionCreators({ ...searchActions }, dispatch),
});

const SearchPageConnected = connect(mapStateToProps, mapDispatchToProps)(SearchPage);

export default SearchPageConnected;
